module.exports = __webpack_public_path__ + "media/images/front/icons/icon_edit-5d4d5d6912782014305b11c26abbce2b.svg";